// extracted by mini-css-extract-plugin
export var box = "_1j-2";
export var checkboxControl = "_1j-0";
export var checkboxRow = "_1j-a";
export var checked = "_1j-3";
export var descriptionSpacer = "_1j-c";
export var disabled = "_1j-4";
export var icon = "_1j-8";
export var input = "_1j-1";
export var labelSpacer = "_1j-b";
export var large = "_1j-7";
export var medium = "_1j-6";
export var small = "_1j-5";
export var text = "_1j-9";